import { useContext } from "react";
import { motion } from "framer-motion";
import { Car, MapPin, Trees, Hotel } from "lucide-react";
import { LanguageContext } from "../App";

const benefitIcons = [Car, MapPin, Trees, Hotel];

export default function TrustStrip() {
  const { t } = useContext(LanguageContext);
  const ts = t.trust_strip;

  return (
    <motion.div
      data-testid="trust-strip"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.2 }}
      className="bg-[#FDFBF7] border-y border-[#DDD8CE] py-4 px-6"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8">

        {/* Stars + text */}
        <div className="flex items-center gap-2 flex-shrink-0">
          <span className="text-[#7B907F] text-sm tracking-wide">{ts.stars}</span>
          <span className="font-['Manrope',sans-serif] text-xs text-[#5C5754] italic">
            {ts.text}
          </span>
        </div>

        {/* Divider — desktop */}
        <div className="hidden sm:block w-px h-5 bg-[#DDD8CE]" />

        {/* Benefits */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {ts.benefits.map((b, i) => {
            const Icon = benefitIcons[i];
            return (
              <span key={i} className="flex items-center gap-1.5 font-['Manrope',sans-serif] text-[11px] uppercase tracking-[0.15em] text-[#8A847F]">
                <Icon size={11} strokeWidth={1.5} className="text-[#7B907F]" />
                {b}
              </span>
            );
          })}
        </div>

        {/* Divider — desktop */}
        <div className="hidden sm:block w-px h-5 bg-[#DDD8CE]" />

        {/* Scarcity */}
        <span className="font-['Manrope',sans-serif] text-[11px] uppercase tracking-[0.1em] text-[#7B907F] font-medium flex-shrink-0 text-center sm:text-left">
          {ts.scarcity}
        </span>

      </div>
    </motion.div>
  );
}
